var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0FD55E5D-1F30-4E60-9157-B8B6FB1C61D1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Jobcare---Tablet---1112-x-834-px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-5---Summary-empty",
    transform: "translate(-512.000000, -1099.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Summary",
    transform: "translate(20.000000, 255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Summary/hazards-list",
    transform: "translate(40.000000, 672.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hazard-empty",
    transform: "translate(69.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-summary-hazards",
    transform: "translate(352.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-hazard",
    transform: "translate(31.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "80x80",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7690403,64 C82.1330268,68 79.168435,73 74.4660436,73 L13.1429059,73 C8.41493286,73 5.47592261,67.9875488 7.82718072,64 L38.4823854,12 C40.8463719,8 46.7627023,8 49.1138357,12 L79.7690403,64 Z",
    id: "Path",
    fill: "#E1E5E5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8,58.6 C45.5714286,58.6 47,60.0285714 47,61.8 C47,63.5714286 45.5714286,65 43.8,65 C42.0285714,65 40.6,63.5714286 40.6,61.8 C40.6,60.0285714 42.0285714,58.6 43.8,58.6 Z M46.191311,26.6 C46.6492853,26.6 47.0130598,26.9876653 46.9996403,27.4584886 L45.9892287,54.5969501 C45.9756776,55.0400541 45.6120347,55.4 45.1808994,55.4 L42.4191076,55.4 C41.9879723,55.4 41.6241978,55.0538462 41.6107783,54.5969501 L40.6003667,27.4584886 C40.5868156,26.9876653 40.9505901,26.6 41.408696,26.6 L46.191311,26.6 Z",
    id: "Combined-Shape",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.3ac3e0f5.svg";
export { ForwardRef as ReactComponent };